import React, { useRef } from 'react';
import moment from 'moment';
import localization from 'moment/locale/id';

moment.updateLocale('id', localization);
var d = new Date();

export default class SicknessPrint extends React.Component {
  constructor(props) {
    super(props);
  }

  setAge(d) {
    var age = moment().diff(d, 'years', true);
    return Math.floor(age);
  }

  render() {
    var Age = this.setAge(this.props.detilPx.patients.birth_date);
    moment.locale('id');
    return (
      <table style={{ margin: '24Px', width: '96%' }}>
        <thead>
          <tr style={{ width: '100%' }}>
            <td style={{ paddingBottom: '13Px', paddingRight: '90Px' }} colSpan="3">
              <img style={{ float: 'left', margin: '12Px', width: '66Px' }} alt="Image placeholder" src={process.env.REACT_APP_LOGO} />
              <center>
                <h3>{this.props.profile.report_header_2}<br></br>
                  {this.props.profile.report_header_1}<br></br>
                  {this.props.profile.name}</h3>{this.props.profile.address} Telp. {this.props.profile.phone}
              </center>
            </td>
          </tr>
        </thead>
        <tbody style={{ width: '100%', borderTop: '3px solid black', borderCollapse: 'collapse', padding: '12Px' }}>
          <tr>
            <td style={{ padding: '12Px' }} colSpan="3">
              <center>
                <u><b>SURAT KETERANGAN SAKIT</b></u><br></br>No. {this.props.sickness ? this.props.sickness.number : ''}<br></br>
              </center>
            </td>
          </tr>
          <tr>
            <td style={{ padding: '12Px' }} colSpan="3">
              Yang bertanda tangan dibawah ini Dokter {this.props.profile.name} {this.props.profile.villages ? this.props.profile.villages.district.city.name : ''}, dengan ini menerangkan bahwa :
                    </td>
          </tr>
          <tr>
            <td style={{ paddingLeft: '12Px', width: '30%' }}>
              Nama
                    </td>
            <td style={{ width: '5%' }}>
              :
                    </td>
            <td style={{ width: '65%' }}>
              {this.props.detilPx.patients ? (this.props.detilPx.patients.name).toUpperCase() : ''}
            </td>
          </tr>
          <tr>
            <td style={{ paddingLeft: '12Px', width: '30%' }}>
              Jenis Kelamin
                    </td>
            <td style={{ width: '5%' }}>
              :
                    </td>
            <td style={{ width: '65%' }}>
              {this.props.detilPx.patients ? (this.props.detilPx.patients.sexs.name).toUpperCase() : ''}
            </td>
          </tr>
          <tr>
            <td style={{ paddingLeft: '12Px', width: '30%' }}>
              Tempat, Tanggal Lahir (Umur)
                    </td>
            <td style={{ width: '5%' }}>
              :
                    </td>
            <td style={{ width: '65%' }}>
              {(this.props.detilPx.patients.birth_place).toUpperCase()}, {moment(this.props.detilPx.patients.birth_date).format('DD-MM-YYYY')}{' '}({Age} TH)
            </td>
          </tr>
          <tr>
            <td style={{ paddingLeft: '12Px', width: '30%' }}>
              Pekerjaan
                    </td>
            <td style={{ width: '5%' }}>
              :
                    </td>
            <td style={{ width: '65%' }}>
              {this.props.detilPx.patients ? (this.props.detilPx.patients.job.name).toUpperCase() : ''}
            </td>
          </tr>
          <tr>
            <td style={{ paddingLeft: '12Px', width: '30%' }}>
              Alamat
                    </td>
            <td style={{ width: '5%' }}>
              :
                    </td>
            <td style={{ width: '65%' }}>
              {(this.props.detilPx.patients.address).toUpperCase()}, {this.props.detilPx.villages.name}, {this.props.detilPx.villages.district.name}, {this.props.detilPx.villages.district.city.name}, {this.props.detilPx.villages.district.city.province.name}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '12Px' }} colSpan="3"><br></br>
              Pada saat pemeriksaan dalam keadaan sakit, sehingga perlu istirahat selama <b>{this.props.sickness ? this.props.sickness.permit_day : '3'} hari</b>.<br></br>
              Mulai tanggal <b>{this.props.sickness ? moment(this.props.sickness.permit_date).format('DD-MM-YYYY') : moment(d).format('YYYY-MM-DD')}</b> s.d. tanggal <b>{this.props.sickness ? moment(this.props.sickness.permit_date).clone().add(this.props.sickness.permit_day - 1, 'days').format('DD-MM-YYYY') : moment(d).format('YYYY-MM-DD')}</b>. Dengan keterangan :<br></br>
              <b>{this.props.sickness ? this.props.sickness.explanation : '-'}</b><br></br><br></br>
              Demikian Surat Keterangan ini dibuat, dengan mengingat sumpah saat menerima jabatan, agar dapat digunakan sebagaimana mestinya.<br></br>
            </td>
          </tr>
          <tr>
            <td style={{ width: '35%' }}>

            </td>
            <td colSpan="2" style={{ padding: '12Px', width: '65%' }}>
              <center>
                {this.props.profile.villages ? (this.props.profile.villages.district.city.name).replace('KABUPATEN ', '') : ''}, {moment(this.props.created_at).format('DD MMMM YYYY')}<br></br>
                Dokter Pemeriksa<br></br>
                <br></br>
                <br></br>
                {this.props.sickness ? this.props.sickness.doctor.name : ''}<br></br>
                NIP. {this.props.sickness ? this.props.sickness.doctor.nip : ''}
              </center>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}